export const CUSTOM_TR_CONTROL_ID = 'custom-tr-control';
